document.addEventListener("DOMContentLoaded", () => {

    BundleUI.render();

    document.querySelectorAll(".bundle-add").forEach(button => {

        button.addEventListener("click", () => {
            const card = button.closest(".mix-card");
            const select = card.querySelector(".mix-size");
            const option = select.selectedOptions[0];

            const result = BundleState.add({
                productId: button.dataset.productId,
                variantId: option.value,
                title: button.dataset.title,
                size: option.text,
                image: button.dataset.image,
                category: button.dataset.category,
                price: Number(option.dataset.price),
                compare: Number(option.dataset.compare || option.dataset.price),
                bundle: Number(option.dataset.bundle || option.dataset.price)
            });

            if (!result.success) {
                alert(result.message);
                return;
            }

            BundleUI.render();

        });

    });

    document
        .getElementById("bundle-checkout")
        .addEventListener("click", () => {
            BundleCart.addBundle();
        });

});
